import { useQuery } from "@apollo/client";
import React, { useState } from "react";
import EmailsForReviewTable from "./EmailsForReviewTable";
import { DATA_FOR_FILTERS_IN_REVIEW_AND_PROCESSED_EMAILS, REVIEW_EMAILS } from "../../api/queries";
import { Box, VStack } from "@chakra-ui/react";
import TableFiltersForm from "../../components/forms/TableFiltersForm";
import useTableFilters from "../../components/forms/useTableFilters";
import { usePaginatedTableRequest } from '@/components/tables/hooks/usePaginatedTableRequest';
import { IEmailAIExtractedData } from "@/types/common";

const EmailsForReview = () => {
  const { filters, setFilters } = useTableFilters();
  const { data: dataForFilters, loading: dataForFiltersLoading } = useQuery(DATA_FOR_FILTERS_IN_REVIEW_AND_PROCESSED_EMAILS, {
    variables: {
      isFailedEmails: true
    }
  });

  const {
    data,
    pagination,
    setPagination,
    loading
  } = usePaginatedTableRequest(REVIEW_EMAILS, filters)


  return (
    <VStack width="100%" gap={4}>
      <TableFiltersForm
        setFilters={setFilters}
        renderFilters={["businessNames", "dbas", "owners", "ssns", "processingDates"]}
        dataForFilters={dataForFilters?.dataForFiltersInReviewAndProcessedEmails}
        dataForFiltersLoading={dataForFiltersLoading}
        tableInitialLoading={loading}
      />
      <EmailsForReviewTable 
        reviewEmails={data?.reviewEmails?.items}
        pagination={pagination}
        setPagination={setPagination}
        totalCount={data?.reviewEmails?.totalCount}
        loading={loading}
      />
    </VStack>
  );
};

export default EmailsForReview;
